import { Button, Input, Notification, Select, toast } from "components/ui";
import { CompanyContext } from "contexts/CompanyContext";
import { ModalContext } from "contexts/ModalContext";
import { TrendingNewsContext } from "contexts/TrendingNewsContext";
import React, { useContext, useEffect, useState } from "react";
import { HiCheckCircle, HiOutlineMagnifyingGlass } from "react-icons/hi2";

import { useNavigate } from "react-router-dom";
import { getHTMLByURL, getReadableByURL } from "utils/getReadableByURL";

import { useTrendingNews } from "utils/hooks/useTrendingNews";
import TrendingNewsItem from "views/home/TrendingNewsItem";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { HiOutlineCheckCircle } from "react-icons/hi2";
import SocialNetworkSidePanel from "views/calendar/SocialNetworkSidePanel";
import InputModern from "components/ui/Input/InputModern";
import { socialNetworkPrompts, socialNetworkPromptsSuffix } from "components/layout/MagicEditor/functions/AdaptToSocialNetwork";
import { CalendarActiveSocialNetworkContext } from "contexts/CalendarActiveSocialNetworkContext";
import { Loading } from "components/shared";
import { Trans, useTranslation } from "react-i18next";
import { AIContext } from "contexts/AIContext";
import usePostGenerationQuantity from "utils/hooks/usePostGenerationQuantity";
import ConfigPanel from "../ConfigPanel";
import { LuLink2 } from "react-icons/lu";
import { proxyUrl } from "utils/proxy";


const URLTemplate = ({
    generatePostsFromContexts,
    config,
    setConfig
}) => {

    const maxSelection = usePostGenerationQuantity();

    const [ url, setUrl ] = useState("");
    const [ quantity, setQuantity ] = useState(1);
    const [ html, setHtml ] = useState();
    const [ readHTML, setReadHTML ] = useState();
    const [ isLoadingHTML, setIsLoadingHTML ] = useState(false);
    const { t } = useTranslation();

    const quantityOptions = Array.from(Array(maxSelection).keys()).map((quantity) => {
        return { value: quantity + 1, label: `Generate ${quantity + 1} option${quantity + 1 > 1 ? `s` : ``}` }
    })

    const getOgImages = () => {
        let images = [];
        try {
            var doc = new DOMParser().parseFromString(html, "text/html");
            const metaTags = doc.querySelectorAll('meta[property="og:image"]');
            if (metaTags?.[0]?.content) {
                // proxyUrl encodes the image URL, so its own query string (e.g. a signature) survives.
                images.push(proxyUrl(metaTags[0].content))
            }
        } catch (err) {}
        return images;
    }

    const handleOnSubmit = async () => {
        const images = getOgImages();
        const textContent = readHTML?.length > 10000 ? readHTML?.textContent?.substring(0, 10000) : readHTML?.textContent;
        generatePostsFromContexts([{ source: { kind: 'webpage', content: (textContent || '').trim() }, link: url }], images, quantity || 1);
    }

    const loadHTML = () => {
        if (!!url) {
            setIsLoadingHTML(true);
            getHTMLByURL(url).then(({article, html}) => {
                var doc = new DOMParser().parseFromString(article?.content, "text/html");
                var elements = doc.getElementsByTagName('img')
                for (var i = 0; i < elements?.length; i++) {
                    elements[i].setAttribute('onerror', "this.style.display='none'");
                }
                article.content = doc.body.outerHTML
                setReadHTML(article);
                setHtml(html);
            }).catch(() => {
                toast.push(<Notification title="I'm sorry, we couldn't read that URL. Please, try another one." type="warning" />)
            }).finally(() => {
                setIsLoadingHTML(false)                    
            });
        } else {
            setReadHTML(undefined);
        }
    }
    
    return (
        <div className="w-full h-full flex items-start p-4 gap-4">
            <ConfigPanel 
                selected={!!readHTML?.textContent && Array.from(Array(quantity).keys())}
                onSubmit={handleOnSubmit}
                config={config}
                setConfig={setConfig}
                template="url"
            />
            <div className="flex-1 flex flex-col lg:flex-row gap-2 w-full h-full overflow-y-auto bg-secondary-500 dark:bg-gray-800 rounded-2xl">
                <div className="overflow-y-auto p-1 shrink-0 flex-1 p-4 flex flex-col">
                    <div className='p-0 relative pb-4'> 
                        <Select
                            placeholder={t(`rawTemplate.placeholderQuantity`)}
                            options={quantityOptions}
                            value={quantityOptions?.filter(e => e.value == quantity)?.[0]}
                            onChange={(option) => setQuantity(option?.value)}
                            className="bg-gray-50 dark:bg-gray-600 rounded-2xl border-0"
                            fieldsetClassName="rounded-2xl !border-0"
                        />
                    </div>
                    <div className='p-0 relative pb-4 flex items-stretch'> 
                        <InputModern
                            placeholder={t(`urlTemplate.placeholderUrl`)}
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            className={`!py-4 !px-4 !h-auto transition-all bg-gray-50 dark:bg-gray-600 rounded-l-2xl !rounded-r-none`}
                            fieldsetClassName="h-full bg-gray-50 dark:bg-gray-600 rounded-l-2xl !rounded-r-none flex-1"
                            onKeyDown={(e) => e.key == 'Enter' && loadHTML()}
                        />
                        <Button
                            variant="twoTone"
                            className="!rounded-l-none !rounded-r-2xl !h-auto"
                            icon={<LuLink2 />}
                            onClick={loadHTML}
                            loading={isLoadingHTML}
                        >
                            Read URL
                        </Button>
                    </div>
                    <div className="pb-8 flex-1">
                        <div className={`!p-6 !px-5 h-full rounded-2xl border border-gray-200 dark:border-gray-700 transition-all ${!url && `text-2xl !text-lighter`}`}>
                            {readHTML && <div dangerouslySetInnerHTML={{__html: readHTML?.content}}></div>}
                            {isLoadingHTML && <div className="my-16"><Loading type={'element'} /></div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default URLTemplate;